/**
 * Platform detection utility
 * Used to conditionally show/hide features based on platform (iOS, Android, Web)
 */
import { Capacitor } from '@capacitor/core';

export const isIOS = () => {
  try {
    return Capacitor.getPlatform() === 'ios';
  } catch {
    return false;
  }
};

export const isAndroid = () => {
  try {
    return Capacitor.getPlatform() === 'android';
  } catch {
    return false;
  }
};

export const isNative = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const isWeb = () => {
  try {
    return Capacitor.getPlatform() === 'web';
  } catch {
    return true;
  }
};
